import React, { useState, useEffect } from 'react';
import { PageMetaLoaderProps, PageMeta } from '../types';
import { useI18n } from '../i18n';
import SeoHead from './SeoHead';

const PageMetaLoader: React.FC<PageMetaLoaderProps> = ({ pageUrl }) => {
  const [pageData, setPageData] = useState<PageMeta | null>(null);
  const { locale } = useI18n();

  useEffect(() => {
    let cancelled = false;
    const suffix = locale === 'km' ? '.km' : '';
    const load = async () => {
      try {
        const response = await fetch(`/data/pages${suffix}.json`);
        if (response.ok) {
          const data: PageMeta[] = await response.json();
          const matchedPage = data.find((page: PageMeta) => page.url === pageUrl);
          if (matchedPage && !cancelled) {
            setPageData(matchedPage);
            return;
          }
        }
      } catch (error) {
        // localized file missing or invalid → fall back to the default below
        if (suffix === '') {
          console.error('Error loading page metadata:', error);
        }
      }
      // Fallback: English metadata
      try {
        const response = await fetch('/data/pages.json');
        const data: PageMeta[] = await response.json();
        const matchedPage = data.find((page: PageMeta) => page.url === pageUrl);
        if (matchedPage && !cancelled) {
          setPageData(matchedPage);
        }
      } catch (error) {
        console.error('Error loading page metadata:', error);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [pageUrl, locale]);

  if (!pageData) {
    return null;
  }

  const path = pageUrl === 'home' ? '/' : `/${pageUrl}`;

  return (
    <SeoHead
      title={pageData.title}
      description={pageData.description}
      keywords={pageData.keywords}
      path={path}
    />
  );
};

export default PageMetaLoader;
